import { ChevronRight } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { Card } from 'src/shared/components/ui/card'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import type { BreadcrumbCategory } from '../hooks'

export const CatalogBreadcrumb = ({
  categories,
  count,
  onBreadcrumbClick,
  onBackToCategories,
}: {
  categories: BreadcrumbCategory[]
  count?: number
  onBreadcrumbClick: (index: number) => void
  onBackToCategories: () => void
}) => {
  const { t } = useLocalization()

  return (
    <Card className="p-4">
      <Row className="items-center justify-between gap-3 flex-wrap">
        <nav
          aria-label={t('Breadcrumb', 'Kategorier')}
          className="flex flex-row flex-wrap items-center gap-2 min-w-0"
        >
          {categories.map((cat, i) => {
            const label = cat.title
              ? t(
                  cat.title.split(',')[0]?.trim() ?? '',
                  cat.title.split(',')[1]?.trim() ?? ''
                )
              : ''
            const isLast = i === categories.length - 1
            return (
              <Row key={cat.id} className="items-center gap-2">
                {i > 0 && (
                  <ChevronRight
                    className="w-4 h-4 shrink-0 text-muted-foreground"
                    aria-hidden
                  />
                )}
                {isLast ? (
                  <h2 className="truncate">{label}</h2>
                ) : (
                  <button
                    type="button"
                    onClick={() => onBreadcrumbClick(i)}
                    className="truncate text-muted-foreground transition-colors hover:text-foreground bg-transparent border-0 p-0 cursor-pointer text-left"
                  >
                    {label}
                  </button>
                )}
              </Row>
            )
          })}
          {count != null && (
            <span className="text-sm text-muted-foreground tabular-nums shrink-0">
              ({count})
            </span>
          )}
        </nav>

        <Button
          variant="secondary"
          size="sm"
          onClick={onBackToCategories}
          className="shrink-0"
        >
          {t('See all categories', 'Visa alla kategorier')}
        </Button>
      </Row>
    </Card>
  )
}
